export default __webpack_public_path__ + "static/media/G0680.34I-26417_-18483_0.1666267560000.b48a6966.jpg";